class PersonalizationPreview extends HTMLElement {
  connectedCallback() {
    this.label = this.querySelector('[data-label]');
    this.canvas = this.querySelector('[data-canvas]');
    this.input = this.querySelector('[data-text-input]');
    this.colorInputs = this.querySelectorAll('[data-color-input]');
    this.colorHidden = this.querySelector('[data-color-hidden]');

    try {
      this.variantImages = JSON.parse(this.dataset.variantImages || '{}');
    } catch (e) {
      this.variantImages = {};
    }

    this.input.addEventListener('input', () => {
      const value = this.input.value.toUpperCase().slice(0, 4);
      this.input.value = value;
      this.label.textContent = value || 'ABC';
      this.label.style.opacity = value ? '1' : '0.35';
    });

    this.colorInputs.forEach((el) => {
      el.addEventListener('change', () => {
        if (el.checked) {
          this.label.dataset.engrave = el.value;
          this.colorHidden.value = el.dataset.colorLabel;
        }
      });
    });

    const form = this.closest('form') || document.querySelector('form[action*="/cart/add"]');
    this.variantInput = form ? form.querySelector('input[name="id"], select[name="id"]') : null;
    if (this.variantInput) {
      const updateFromVariant = () => {
        const entry = this.variantImages[this.variantInput.value];
        if (entry && this.canvas) {
          this.canvas.style.backgroundImage = `url('${entry.url}')`;
          this.canvas.style.backgroundSize = entry.size;
          this.canvas.style.backgroundPosition = entry.position;
        }
      };
      new MutationObserver(updateFromVariant).observe(this.variantInput, { attributes: true, attributeFilter: ['value'] });
      this.variantInput.addEventListener('change', updateFromVariant);
      document.addEventListener('change', (e) => {
        if (e.target && e.target.name === 'id') updateFromVariant();
      });
    }
  }
}

customElements.define('personalization-preview', PersonalizationPreview);
